import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../../features/auth/services/auth.service';

export const superuserGuard: CanActivateFn = async (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    // Roles come from the bank profile, which is fetched after login. Reading them
    // early would bounce a genuine super user off a deep link or refresh.
    await authService.profileReady();

    if (!authService.isSuperUser) {
        if (state.url !== '/no-access') {
            router.navigate(['/no-access']);
        }
        return false;
    }

    return true;
};
